import Component from 'inferno-component';
import { Container, Header, Table, Grid, Responsive } from 'semantic-ui-react';

const tenSecPrice = "14,5";
const twentySecPrice = "21,75";
const priceBase = "Ft / hallgató";

export default class Prices extends Component {
  render() {
    return (
      <Container fluid  className="spb">
        <Container>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <Responsive {...Responsive.onlyMobile}>
                  <p>
                    <strong>10&nbsp;mp-es&nbsp;reklámspot&#58;</strong><br/> {tenSecPrice}&nbsp;{priceBase}<br/>
                    <strong>20&nbsp;mp-es&nbsp;reklámspot&#58;</strong><br/> {twentySecPrice}&nbsp;{priceBase}
                  </p>
                </Responsive>
                <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                  <Table celled padded>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell singleLine><Header as="h3" textAlign='center'>10 mp-es reklámspot</Header></Table.HeaderCell>
                       <Table.HeaderCell singleLine><Header as="h3" textAlign='center'>20 mp-es reklámspot</Header></Table.HeaderCell>
                     </Table.Row>
                    </Table.Header>
                    <Table.Body>
                     <Table.Row>
                       <Table.Cell singleLine>
                          <Header as="h5" textAlign='center'>{tenSecPrice}&nbsp;{priceBase}</Header>
                       </Table.Cell>
                        <Table.Cell singleLine>
                          <Header as="h5" textAlign='center'>{twentySecPrice}&nbsp;{priceBase}</Header>
                        </Table.Cell>
                      </Table.Row>
                    </Table.Body>
                  </Table>
                 </Responsive>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                  <p style={{color: 'black', paddingBottom: '30px'}} >
                    A feltűntetett árak ügyfélkedvezmény nélküli nettó listaárak, melyek a teljes rendszeren történő egyidejű hirdetési igény esetén érvényesek, az általános tájékoztatóban szereplő megjelenési számok érvényesülésekor. Leendő partnereink felmerülő igényeire egyedi árazással állunk rendelkezésre.
                  </p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prices/Prices.js